module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "experience"
  }, [_c('h3', [_vm._v("Experience")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "exp-item"
  }, [_c('div', {
    staticClass: "job"
  }, [_c('a', {
    staticClass: "company",
    attrs: {
      "href": "http://www.whalerockindustries.com/",
      "target": "_blank"
    }
  }, [_vm._v("Whalerock Digital Media LLC.")]), _vm._v(" "), _c('div', {
    staticClass: "duration"
  }, [_vm._v("Jul '16 — Current")])]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("Software Engineer, Fullstack")])]), _vm._v(" "), _c('div', {
    staticClass: "exp-item"
  }, [_c('div', {
    staticClass: "job"
  }, [_c('a', {
    staticClass: "company",
    attrs: {
      "href": "https://www.leafgroup.com/",
      "target": "_blank"
    }
  }, [_vm._v("Demand Media Inc.")]), _vm._v(" "), _c('div', {
    staticClass: "duration"
  }, [_vm._v("Sep '15 — Jun '16")])]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("Sr. Software Engineer")])]), _vm._v(" "), _c('div', {
    staticClass: "exp-item"
  }, [_c('div', {
    staticClass: "job"
  }, [_c('a', {
    staticClass: "company",
    attrs: {
      "href": "https://www.leafgroup.com/",
      "target": "_blank"
    }
  }, [_vm._v("Demand Media Inc.")]), _vm._v(" "), _c('div', {
    staticClass: "duration"
  }, [_vm._v("Jun — Sep '15")])]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("Software Engineer")])]), _vm._v(" "), _c('div', {
    staticClass: "exp-item"
  }, [_c('div', {
    staticClass: "job"
  }, [_c('a', {
    staticClass: "company",
    attrs: {
      "href": "https://www.leafgroup.com/",
      "target": "_blank"
    }
  }, [_vm._v("Demand Media Inc.")]), _vm._v(" "), _c('div', {
    staticClass: "duration"
  }, [_vm._v("Feb — May '14")])]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("Software Engineer Intern")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f4c43d2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sections/Experience.vue
// module id = 54
// module chunks = 0